import '../scss/app.scss'; // Importing SCSS file

class EventCheckPopupManager {
    constructor() {
        this.popup = {
            element: null,
            closeButton: null
        };
        // this.customColors = customColors;

        this.view_this_event_text = document.getElementById('view-this-event-text');
        this.moxcar_event_days = document.querySelectorAll('.moxcar-event-calendar-day');
    }

    init() {
        this.events();
    }

    /**
     * Creates and returns a popup element from event details using a more structured and maintainable approach.
     * The calling function is responsible for appending this element to the DOM.
     *
     * @param {object} details - The object containing event data.
     * @returns {HTMLElement} The generated popup section element.
     */
    createPopup(details) {
        // 1. --- DATA PREPARATION ---
        const data = details.data || details;
        const eventDetails = data.eventDetails || {};
        const venueDetails = data.venueDetails || {};
        const organizerDetails = data.organizerDetails || {};

        const hasValue = (value) => typeof value === 'string' && value.trim() !== '';
        const hasArrayValue = (arr) => Array.isArray(arr) && arr.length > 0 && arr.some(item => hasValue(item));

        // Prepare event link; prefer canonical event permalink when available.
        let eventLink = (eventDetails.event_permalink || eventDetails.event_website || '#');

        // 2. --- CREATE POPUP STRUCTURE ---
        const popup = document.createElement('section');
        popup.className = 'ec-popup';
        popup.id = 'popup'; // Keep the ID for consistency if needed elsewhere

        const card = document.createElement('div');
        card.className = 'ec-popup__card';
        popup.appendChild(card);

        // --- Helper function to create meta items ---
        const createMetaItem = (title, content, isLink = false, linkText = "Visit Event Website") => {
            if (!hasValue(content) && !hasArrayValue(content)) return '';
            let contentHtml;
            if (Array.isArray(content)) {
                contentHtml = content.filter(hasValue).join('<br>');
            } else if (isLink) {
                contentHtml = `<a href="${content}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
            } else {
                contentHtml = content;
            }
            return `
                <div class="ec-popup__meta-item">
                    <h4 class="ec-popup__meta-title">${title}</h4>
                    <p>${contentHtml}</p>
                </div>
            `;
        };

        const createOrganizerItem = (organizer) => {
            let parts = [];
            if (hasValue(organizer.organizer_name)) parts.push(organizer.organizer_name);
            if (hasValue(organizer.organizer_email)) parts.push(organizer.organizer_email);
            if (hasValue(organizer.organizer_phone)) parts.push(organizer.organizer_phone);
            if (hasValue(organizer.organizer_website)) parts.push(`<a href="${organizer.organizer_website}" target="_blank" rel="noopener noreferrer"> 
                Visit Organizer Website
                </a>`);

            if (parts.length === 0) return '';

            return `
                 <div class="ec-popup__meta-item">
                    <p>${parts.join('<br>')}</p>
                </div>
            `;
        };

        console.log('Event Details:', eventDetails);
 
    const convert_commas_to_br = (content) => {
        if (!content || typeof content !== 'string') return '';
        return content.split(',').map(item => item.trim()).filter(item => item).join('<br>');
    }

// The comment below is a placeholder, as the "Event Admittance" is currently hardcoded.
// This can be updated later if the data becomes available in the API.
card.innerHTML = `
    <button class="ec-popup__close">×</button>
    
    <h2 class="ec-popup__title">${eventDetails.event_title || 'Event Details'}</h2>
    
    ${hasValue(eventDetails.event_date) ? `<p class="ec-popup__date">${eventDetails.event_date}</p>` : ''}
    ${eventLink !== '#' ? `<a href="${eventLink}" class="ec-popup__button" target="_blank" rel="noopener noreferrer">GET THIS EVENT LINK</a>` : ''}
    
    ${hasValue(eventDetails.event_content) ? `<div class="ec-popup__description">
        ${eventDetails.event_content}
        
        </div>` : ''}

    <div class="ec-popup__meta">
 
        <div class="ec-popup__meta-group">
            <h3 class="ec-popup__meta-heading">Details</h3>
             ${createMetaItem('Attended By',  convert_commas_to_br(eventDetails.event_attended_by))}

            ${createMetaItem('Attire', convert_commas_to_br(eventDetails.event_attire))}
            ${createMetaItem('Event Admittance', eventDetails.event_admittance)}
            ${createMetaItem('Event Website', eventDetails.event_website, true)}
            ${createMetaItem('Ticket Link', eventDetails.event_ticket_link, true, 'VISIT TICKET LINK')}
            ${createMetaItem('RSVP Deadline', eventDetails.event_rsvp_deadline)}
        </div>

 
        ${(hasValue(organizerDetails.organizer_name) || hasValue(organizerDetails.organizer_phone) || hasValue(organizerDetails.organizer_website)) ? `
        <div class="ec-popup__meta-group">
            <h3 class="ec-popup__meta-heading">Organizer</h3>
            ${createOrganizerItem(organizerDetails)}
        </div>
        ` : ''}

 
        ${(hasValue(venueDetails.venue_name) || hasValue(venueDetails.venue_address)) ? `
        <div class="ec-popup__meta-group">
            <h3 class="ec-popup__meta-heading">Venue</h3>
            <address class="ec-popup__meta-item">
                ${hasValue(venueDetails.venue_name) ? `${venueDetails.venue_name}<br>` : ''}
                ${hasValue(venueDetails.venue_address) ? venueDetails.venue_address : ''}
            </address>
                      ${hasValue(venueDetails.venue_directions) ? `<a href="${venueDetails.venue_directions}" class="ec-popup__directions" target="_blank" rel="noopener noreferrer">Directions</a>` : ''}

            ${hasValue(venueDetails.venue_phone) ? `<p 
                style="margin: 0.25rem 0;"
                class="ec-popup__venue-phone">${venueDetails.venue_phone}</p>` : ''}

            ${hasValue(venueDetails.venue_website) ? `<a 
                style="display: block; margin-top: 0.25rem;"
                href="${venueDetails.venue_website}" class="ec-popup__venue-website" target="_blank" rel="noopener noreferrer">Visit Venue Website </a>` : ''}
        </div>
        ` : ''}
    </div>
`;

        // 4. --- EVENT LISTENERS ---
        const closeButton = card.querySelector('.ec-popup__close');
        closeButton.onclick = () => popup.remove();

        // Close when clicking the dark overlay (the popup element itself), but not the card
        popup.onclick = (e) => {
            if (e.target === popup) {
                popup.remove();
            }
        };

        return popup;
    }

    events() {
        this.moxcar_event_days.forEach(day => {
            day.addEventListener('click', async (e) => {
                e.preventDefault();
                const target = e.target;
                const dayElement = target.closest('.moxcar-event-calendar-day');
                if (!dayElement) return;

                const windowWidth = window.innerWidth;

                // On desktop, clicking a specific event link opens the detailed popup.
                if (windowWidth > 768) {
                    const eventLink = target.closest('.event-link');
                    if (eventLink) {
                        const eventId = eventLink.id;
                        const data = await this.fetchEventDetailsById(eventId);
                        if (data) {
                            const popup = this.createPopup(data);
                            document.body.appendChild(popup);
                        }
                    }
                    return;
                }

                // On mobile, clicking anywhere on a day with events opens the mobile list popup.
                if (windowWidth <= 768) {
                    const eventLinks = dayElement.querySelectorAll('.event-link');
                    if (eventLinks.length > 0) {
                        // Remove any existing mobile popups first to prevent duplicates.
                        const existingPopup = document.querySelector('.ec-popup.mobile');
                        if (existingPopup) {
                            existingPopup.remove();
                        }

                        const mobilePopup = this.createMobilePopup(eventLinks, dayElement);
                        document.body.appendChild(mobilePopup);
                    }
                }
            });
        });
    }

    async fetchEventDetailsById(eventId) {
        try {
            const response = await fetch(`/wp-json/eventcheck/v1/event-details/${eventId}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching event details:', error);
            return null;
        }
    }

    /**
     * Creates a mobile-friendly popup that lists all events for a given day.
     * @param {NodeListOf<Element>} links - A list of event link elements for the day.
     * @param {Element} dayElement - The parent day element from the calendar.
     * @returns {HTMLElement} The generated mobile popup element.
     */
    createMobilePopup(links, dayElement) {
        // Extract date information from the day element's ID (e.g., 'day-2025-07-28')
        const getDateStringFromDayElement = (dayEl) => {
            let dateString = dayEl.id.replace('day-', '');
            let [year, month, day] = dateString.split('-');
            if (parseInt(day, 10) < 19 && day.length === 1) {
                day = '0' + day;
                dateString = `${year}-${month}-${day}`;
            }
            return dateString;
        };

        const dateString = getDateStringFromDayElement(dayElement);

        const date = new Date(`${dateString}T00:00:00`); // Use T00:00:00 to avoid timezone issues
        const dayOfWeek = date.toLocaleDateString('en-US', {
            weekday: 'short'
        }).toUpperCase();
        const fullDate = date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }).toUpperCase();

        const popup = document.createElement('section');
        popup.className = 'ec-popup mobile';

        const card = document.createElement('div');
        card.className = 'ec-mobile-popup';
        popup.appendChild(card);

        // Create the list of event items
        const eventItemsHTML = [...links].map(link => {
            const eventTitle = link.textContent || 'Untitled Event';
            return `
                <div class="ec-mobile-popup__event-item" data-event-id="${link.id}">
                    <div class="ec-mobile-popup__date">
                        <span class="ec-mobile-popup__day">${dayOfWeek}</span>
                        <span class="ec-mobile-popup__fulldate">${fullDate}</span>
                    </div>
                    <div class="ec-mobile-popup__title">
                        ${eventTitle}
                    </div>
                </div>
            `;
        }).join('');

        card.innerHTML = `
            <button class="ec-mobile-popup__close">×</button>
            <div class="ec-mobile-popup__events">
                ${eventItemsHTML}
            </div>
        `;

        // --- EVENT LISTENERS ---
        const closeButton = card.querySelector('.ec-mobile-popup__close');
        closeButton.onclick = () => popup.remove();

        // Close by clicking the overlay
        popup.onclick = (e) => {
            if (e.target === popup) {
                popup.remove();
            }
        };

        // Add click listeners to each event item to open the detailed view
        const eventItems = card.querySelectorAll('.ec-mobile-popup__event-item');
        eventItems.forEach(item => {
            item.addEventListener('click', async () => {
                const eventId = item.dataset.eventId;
                if (!eventId) return;

                const data = await this.fetchEventDetailsById(eventId);
                if (data) {
                    // Create and show the detailed popup
                    const desktopPopup = this.createPopup(data);
                    document.body.appendChild(desktopPopup);
                    // Remove the mobile list popup
                    popup.remove();
                }
            });
        });

        return popup;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const eventCheckPopupManager = new EventCheckPopupManager();
    eventCheckPopupManager.init();
    colorCodeControlHandler();
});

function colorCodeControlHandler() {
    let color_codes = [...document.querySelectorAll('.color-code')];
    let events = document.querySelectorAll('.moxcar-event-item');

    for (const color_code of color_codes) {
        color_code.onclick = function() {
            let category = this.dataset.category;

            let other_color_codes = color_codes.filter(code => code !== this);
            other_color_codes.forEach(code => {
                if (category === "All Events") {
                    code.classList.remove('inactive');
                } else {
                    code.classList.add('inactive');
                }
            });

            this.classList.remove('inactive');

            events.forEach(event => {
                let eventCategory = event.dataset.category.toLowerCase().trim().replace("holiday observance", "holiday");

                console.log({
                    category: category,
                    eventCategory: eventCategory
                });

                if (category.toLowerCase().trim() === 'all events' || eventCategory === category.toLowerCase().trim()) {
                    event.classList.remove('inactive');
                } else {
                    event.classList.add('inactive');
                }
            });
        };
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const monthYearSelector = document.querySelector(".month-year-selector");
    const yearDisplay = document.querySelector(".event-year");
    const prevMonthBtn = document.querySelector(".previous-month");
    const prevYearBtn = document.querySelector(".previous-year");
    const nextMonthBtn = document.querySelector(".next-month");
    const nextYearBtn = document.querySelector(".next-year");
    const calendarBody = document.querySelector(".calendar-body");
    const baseUrl = window.location.origin;
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const shortMonthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    if (!monthYearSelector || !yearDisplay || !prevMonthBtn || !prevYearBtn || !nextMonthBtn || !nextYearBtn || !calendarBody) {
        return;
    }

    let currentYear = new URLSearchParams(window.location.search).get("yr") || new Date().getFullYear();
    let currentMonth = new URLSearchParams(window.location.search).get("month") || (new Date().getMonth() + 1).toString().padStart(2, '0');

    function updateMonthYearLabel() {
        const monthIndex = parseInt(currentMonth, 10) - 1;
        yearDisplay.textContent = `${shortMonthNames[monthIndex]} ${currentYear}`;
    }

    function getMonthUrl(month, year) {
        return `${baseUrl}/?month=${month}&yr=${year}`;
    }

    function navigateToMonthYear(month, year) {
        currentMonth = month;
        currentYear = parseInt(year, 10);
        monthYearSelector.classList.add("is-loading");
        updateMonthYearLabel();
        populateCalendar();
        window.location.href = getMonthUrl(currentMonth, currentYear);
    }

    function populateCalendar() {
        calendarBody.innerHTML = "";

        months.forEach((month, index) => {
            let monthNum = (index + 1).toString().padStart(2, '0');
            let link = document.createElement("a");
            link.href = getMonthUrl(monthNum, currentYear);
            link.textContent = month;

            if (monthNum === currentMonth) {
                link.classList.add("active");
            }

            let div = document.createElement("div");
            div.classList.add("calendar-body-item");
            div.appendChild(link);
            calendarBody.appendChild(div);
        });
    }

    calendarBody.addEventListener("click", (event) => {
        const monthLink = event.target.closest(".calendar-body-item a");

        if (!monthLink) {
            return;
        }

        monthYearSelector.classList.add("is-loading");
    });

    function updateMonth(change) {
        let monthIndex = parseInt(currentMonth, 10) - 1 + change;

        if (monthIndex < 0) {
            monthIndex = 11;
            currentYear = parseInt(currentYear, 10) - 1;
        } else if (monthIndex > 11) {
            monthIndex = 0;
            currentYear = parseInt(currentYear, 10) + 1;
        }

        currentMonth = (monthIndex + 1).toString().padStart(2, '0');
        navigateToMonthYear(currentMonth, currentYear);
    }

    function updateYear(change) {
        currentYear = parseInt(currentYear, 10) + change;
        navigateToMonthYear(currentMonth, currentYear);
    }

    prevMonthBtn.addEventListener("click", () => updateMonth(-1));
    nextMonthBtn.addEventListener("click", () => updateMonth(1));
    prevYearBtn.addEventListener("click", () => updateYear(-1));
    nextYearBtn.addEventListener("click", () => updateYear(1));

    updateMonthYearLabel();
    populateCalendar();
});
